import { safeHTML } from "@lib/html";
import { ReactNode } from "react";

const EventDetailAbout = ({
  title,
  content,
  containerClassName = "w-full px-0",
}: {
  title: ReactNode;
  content: string;
  containerClassName?: string;
}) => {
  return (
    <div className={`${containerClassName} html-container`}>
      {title && (
        <div className="text-2xl mb-4 capitalize dark:text-white">
          <i>{title}</i>
        </div>
      )}
      <div
        className="dark:text-white text-black whitespace-pre-wrap font-medium"
        dangerouslySetInnerHTML={safeHTML(content)}
        /* style={{ color: useColorModeValue("#444444", "#DEDEE0") }} */
      ></div>
    </div>
  );
};

export default EventDetailAbout;
